

// Class Definition
var TextInvertComponent = function() {
    var initInvert = function() {

        var flipText = function(text, backwards, upsideDown) {
            var convertedTxt = "";
            var convertedHTML = "";
            var doConvertedHTML = $("cConvertedHTML").hasClass("show") ? true : false;
            for (var c = text.length - 1; c >= 0; c--) {
                var p = null;
                var didConvertedHTML = false;
                var g = backwards ? c : -1 * (c - text.length + 1);
                var s = text.charAt(g);
                if (doConvertedHTML) {
                    var cHTMLLen = convertedHTML.length;
                    var cHTMLLast = cHTMLLen >= 1 ? convertedHTML.charAt(cHTMLLen - 1) : "";
                    if (s == " " && (cHTMLLast == " " || convertedHTML.substring(cHTMLLen - 6) == "&nbsp;")) {
                        convertedHTML += "&nbsp;";
                        didConvertedHTML = true;
                    } else if (s == "\n") {
                        didConvertedHTML = true;
                    } else if (s == "\r" && cHTMLLast == "\n" && (cHTMLLen < 2 || s.charAt(cHTMLLen - 2) != "\r")) {
                    }
                }
                if (upsideDown) {
                    p = flipTable[s] || flipTableFlipped[s] || flipTable[s.toLowerCase()] || s;
                } else {
                    p = s;
                }
                convertedTxt += p;
                if (doConvertedHTML && !didConvertedHTML) {
                    convertedHTML += flipTableHTML[p] || HTMLTable[p] || p;
                    didConvertedHTML = true;
                }
            }
            return Array(convertedTxt, convertedHTML);
        }
        

        
        var original = $("#textInvert");
        var converted = $("#textResult");
       
        var lastOriginalV = "";
        var justChange = function () {
            
            console.log("justChange");
            lastOriginalV = original.val();
            let converts = flipText(lastOriginalV, $("#invertMyText").is(':checked'), $("#upSideMyText").is(':checked'));
            converted.val(converts[0]) ;
           
        };
        var checkChange = function () {
            if (original.val() != lastOriginalV) {
                justChange();
            }
        };

        original.on("change paste keyup", function () {
            checkChange();
        });

   
        $("#invertMyText").on("click", function () {
            justChange();
        });
        
        $("#upSideMyText").on("click", function () {
            justChange();
        });
      
         

    }

    return {
        init: function() {
            initInvert();
        }
    };
}();

// Class Initialization
$(function(){
    TextInvertComponent.init();
    
    
});


